// removed by extract-text-webpack-plugin
module.exports = {"shadeMedium":"rgb(142, 141, 142)","panel":"tab-panel__panel____1XSOa","accordion":"tab-panel__accordion____tr5Xs"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/components/tab-panel/tab-panel.css
// module id = 689
// module chunks = 0